import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../components/AuthContext";
// LocalStorage Keys
const STORAGE_KEY00 = "iris_ewaybill_shared_config";
const LATEST_EWB_KEY = "latestEwbData";
const EWB_HISTORY_KEY = "ewbHistory";


const FetchEWBbyNumber = () => {
  const [ewbNo, setEwbNo] = useState("");
  const { companyId, token } = useAuth();
  const [userGstin, setUserGstin] = useState("");
  const [updateNeeded, setUpdateNeeded] = useState(true);

  const [authData, setAuthData] = useState({ companyId: "", token: "" });
  const [requestHeaders, setRequestHeaders] = useState({});
  const [requestPayload, setRequestPayload] = useState({});
  const [responseData, setResponseData] = useState(null);
  const [autoFields, setAutoFields] = useState({});

  // Get values directly from localStorage
  const [selectedEnv, setSelectedEnv] = useState(
    localStorage.getItem("connectionType") || "DEFAULT"
  );

  
  // Load Auth + Last EWB Auto Populate
 useEffect(() => {
  const login = JSON.parse(
    localStorage.getItem(STORAGE_KEY00) || "{}"
  );

  const latestEwb = JSON.parse(
    localStorage.getItem(LATEST_EWB_KEY) || "{}"
  );

  console.log("login", login);
  console.log("latestEwb", latestEwb);

  setAuthData({
    companyId: companyId || "",
    token: token || "",
  });

  if (latestEwb?.ewbNo) {
    setEwbNo(latestEwb.ewbNo);
  }

  const gstin =
    latestEwb?.fromGstin ||
    latestEwb?.fullApiResponse?.response?.dispatchFromGstin ||
    latestEwb?.response?.userGstin ||
    login?.userGstin ||
    "";

  setUserGstin(gstin);

  if (latestEwb?.response) {
    setAutoFields(latestEwb.response);
  }
}, [companyId, token]);

  // Save History
  const saveHistory = (entry) => {
    let history = JSON.parse(localStorage.getItem(EWB_HISTORY_KEY) || "[]");
    history.unshift({ time: new Date().toLocaleString(), ...entry });
    if (history.length > 10) history = history.slice(0, 10);
    localStorage.setItem(EWB_HISTORY_KEY, JSON.stringify(history));
  };

  // Fetch EWB API
 const fetchEWB = async () => {

      // Read latest values from localStorage
    const currentConnectionType =
      localStorage.getItem("connectionType") || "DEFAULT";

 const headers = {
  accept: "application/json",
  product: "TOPAZ",
  companyId,
  "X-Auth-Token": token,
  ConnectionType: currentConnectionType,
};

  const payload = {
    ewbNo,
    userGstin,
    updateNeeded: false,
  };

  setRequestHeaders(headers);
  setRequestPayload(payload);

  try {
    const res = await axios.get(
      "https://einvoice.fcssoftwares.com/api/gst/ewaybill/by-number",
      {
        params: payload,
        headers,
      }
    );

    setResponseData(res.data);

    const extracted = res.data?.response || {};
    setAutoFields(extracted);

    const latestDataToSave = {
      ewbNo,
      fromGstin: extracted?.fromGstin || userGstin,
      response: extracted,
    };

    localStorage.setItem(
      LATEST_EWB_KEY,
      JSON.stringify(latestDataToSave)
    );

    saveHistory({
      requestHeaders: headers,
      requestPayload: payload,
      response: res.data,
    });
  } catch (err) {
    const errorData =
      err.response?.data || {
        error: err.message,
      };

    console.error("API Error:", errorData);

    setResponseData(errorData);

    saveHistory({
      requestHeaders: headers,
      requestPayload: payload,
      response: errorData,
    });
  }
};
const rowStyle = {
  display: "flex",
  alignItems: "center",
  marginBottom: "18px",
};

const labelStyle = {
  width: "180px",
  fontWeight: "600",
  fontSize: "16px",
  color: "#333",
};

const inputStyle = {
  width: "400px",
  padding: "10px 12px",
  fontSize: "16px",
  border: "2px solid #1d3557",
  borderRadius: "8px",
  outline: "none",
};
  return (
    <div style={{ padding: 20, maxWidth: 1000, margin: "auto", fontFamily: "Arial, sans-serif" }}>
      <h1 style={{ textAlign: "center" }}>🔍 Fetch E-Waybill By Number</h1>

      {/* INPUTS */}
   {/* EWB Number */}
<div style={rowStyle}>
  <label style={labelStyle}>EWB Number</label>

  <input
    type="text"
    value={ewbNo}
    onChange={(e) => setEwbNo(e.target.value)}
    style={inputStyle}
  />
</div>

{/* User GSTIN */}
<div style={rowStyle}>
  <label style={labelStyle}>User GSTIN</label>

  <input
    type="text"
    value={userGstin}
    onChange={(e) => setUserGstin(e.target.value)}
    style={inputStyle}
  />
</div>

{/* Update Needed */}
<div style={rowStyle}>
  <label style={labelStyle}>Update Needed</label>

  <select
    value={updateNeeded}
    onChange={(e) => setUpdateNeeded(e.target.value === "true")}
    style={inputStyle}
  >
    <option value="true">true</option>
    <option value="false">false</option>
  </select>
</div>

      <button
        onClick={fetchEWB}
        style={{ padding: "10px 20px", backgroundColor: "#1A73E8", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer" }}
      >
        Fetch EWB
      </button>

      <hr style={{ margin: "25px 0" }} />
      {/* RESPONSE */}
      <div style={{ background: "#e8ffe8", padding: 15, borderRadius: 8, marginBottom: 20 }}>
        <h3>📌 Response</h3>
        <pre>{JSON.stringify(responseData, null, 2)}</pre>
      </div>

      {/* AUTO-POPULATED DATA */}
      {autoFields && Object.keys(autoFields).length > 0 && (
        <div style={{ background: "#fff3cd", padding: 15, borderRadius: 8, marginBottom: 20 }}>
          <h3>📌 Auto-Populated Data (From Previous EWB)</h3>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <tbody>
              {Object.entries(autoFields).map(([key, value]) => (
                <tr key={key}>
                  <td style={{ padding: 6, fontWeight: "bold", border: "1px solid #ccc" }}>{key}</td>
                  <td style={{ padding: 6, border: "1px solid #ccc" }}>{String(value)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default FetchEWBbyNumber;
